import { AffiliatePartners } from "./affiliate-partners";

export const REDIRECT_HOSTS = {
  [AffiliatePartners.BOOKING_COM]: "sp.booking.com",
  busbud: "www.busbud.com"
};
